<template>
    <div class="modal fade" id="add_new_referer_modal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <form @submit.prevent="addNewReferer()" id="add_new_referer_form">
                        <div v-if="new_referer != null" class="row">
                            <div class="col-12 col-md-9 my-2">
                                <label for="title" v-text="$t('label.referer')"></label>
                                <input id="title"
                                       name="title"
                                       disabled
                                       v-model="new_referer.title"
                                       class="form-control">
                            </div>
                            <div class="col-12 col-md-3 my-2">
                                <label for="referer_percent" v-text="$t('label.percent')"></label>
                                <input id="referer_percent"
                                       name="referer_percent"
                                       v-model="new_referer.referer_percent"
                                       class="form-control">
                            </div>
                        </div>
                        <div>
                            <button type="button" class="mx-2 btn btn-secondary" @click="resetNewReferer()"
                                    data-dismiss="modal" v-text="$t('label.cancel')"></button>
                            <button type="submit" class="mx-2 btn btn-primary" v-text="$t('btn.add')"></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import {marketingProfitTypes} from '@/constants/marketingProfitType'

export default {
    props: ['new_referer','referer_list'],
    data() {
        return {
            marketingProfitTypes
        };
    },
    methods: {
        addNewReferer() {
            if (this.new_referer != null && this.new_referer != '') {
                let form = $('#add_new_referer_form');

                form.validate({
                    rules: {
                        referer_percent: {
                            required: true,
                            min: 1,
                            max: 100,
                        },
                    },
                });

                if (!form.valid()) {
                    form.off('.validate').removeData('validator').removeData("unobtrusiveValidation");
                    return;
                }
                form.off('.validate').removeData('validator').removeData("unobtrusiveValidation");

                for (let i = 0; i < this.referer_list.length; ++i) {
                    if (this.referer_list[i].id == this.new_referer.id) {
                        this.error_text = i18n.t('marketing.cant_add_referer_again');
                        this.has_error = true;
                        $('#add_new_referer_modal').modal('toggle');
                        this.$emit('reset-referer')
                        return;
                    }
                }

                this.has_error = false;
                this.error_text = '';
                const parts = this.new_referer.title.split(" - ");
                let full_name = parts[0] || "";
                let phone = parts[1] || "";
                this.$emit('add-referer', {
                    full_name: full_name,
                    phone: phone,
                    id: this.new_referer.id,
                    marketing_profit_type : marketingProfitTypes.SPECIFIC_USER_PROFIT,
                    specific_referer_profit_percent : 0,
                    default_profit_percent : 0,
                    referer_percent: parseFloat(this.new_referer.referer_percent), });

                $('#add_new_referer_modal').modal('toggle');
                this.$emit('reset-referer');
            }
        }
    }
}
</script>
<style scoped>

</style>